import { render, staticRenderFns } from "./jjrgzlc.vue?vue&type=template&id=5b5b310f&scoped=true"
import script from "./jjrgzlc.vue?vue&type=script&lang=js"
export * from "./jjrgzlc.vue?vue&type=script&lang=js"
import style0 from "./jjrgzlc.vue?vue&type=style&index=0&id=5b5b310f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b310f",
  null
  
)

export default component.exports